import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { DesktopOutlined, BulbOutlined, DatabaseOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { fetchCategoriesService } from '../../services/CategoryService';

// Define icon components for each category
const icons = {
    Technology: <DesktopOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    Science: <BulbOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    Database: <DatabaseOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    Health: <BulbOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    Art: <DesktopOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    Finance: <DatabaseOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
    // Add a default icon just in case a category name doesn't match
    Default: <DatabaseOutlined style={{ fontSize: '2rem', color: '#5DB075' }} />,
};

// Removed the static 'categories' array as it was unused

const CategoryCard = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const fetchCategories = await fetchCategoriesService();
                setCategories(fetchCategories);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
    }, []);

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Categories</h2>
            <Row gutter={[16, 16]}>
                {categories.map((category) => (
                    <Col xs={24} sm={12} md={8} key={category.name}>
                        
                        {/* 1. Make the Link 100% height and a block element */}
                        <Link 
                            to={`/search/${category.name}`}
                            style={{ 
                                textDecoration: 'none', 
                                height: '100%', 
                                display: 'block' 
                            }}
                        >
                            <Card
                                style={{
                                    borderRadius: '8px',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    height: '100%' // 2. THE FIX: Make the Card fill 100% of the Link's height
                                }}
                            >
                                {/* 3. (Bonus) Use the dynamic icon from your 'icons' object */}
                                <div style={{ marginBottom: '10px' }}>
                                    {icons[category.name] || icons.Default}
                                </div>
                                <h3 style={{ fontSize: '1.2rem', margin: '0', color: '#4A4A4A' }}>
                                    {category.name}
                                </h3>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default CategoryCard;